<template>
  <v-card>
    <v-tabs
      v-model="tab"
      background-color="blue-grey lighten-5"
    >
      <v-tab key="tab_configs">Configs</v-tab>
      <v-tab key="tab_orders">Orders</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="mt-4">
      <v-tab-item key="tab_configs">
        <r-daily-quest-configs/>
      </v-tab-item>
      <v-tab-item key="tab_orders">
        <r-daily-quest-orders/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import RDailyQuestConfigs from "@/modules/redactor/views/daily-quest/r-daily-quest-configs.vue";
import RDailyQuestOrders from "@/modules/redactor/views/daily-quest/r-daily-quest-orders.vue";

export default {
    name: "r-daily-quest-page",
    components: {RDailyQuestOrders, RDailyQuestConfigs},
    data: () => ({
        tab: null
    })
}

</script>